import React from 'react';
import { convertPxToRem } from '../../helper';
import { Input } from 'antd';
import TextBase from '../text';
import { Colors } from '../../themes/Colors';
import './index.css';

export const FormInput = ({
  placeholder = 'Placeholder',
  label = '',
  onChange = () => {},
  bg = 'grey',
  inputStyle = {},
  disabled = false,
  value = '',
  error = ''
}) => {
  return (
    <div style={{ position: 'relative', marginBottom: 'calc(var(--sp-md2)*1.886792)' }}>
      {label?.length ? (
        <TextBase
          className="no-select"
          style={{ textAlign: 'left' }}
          size={'var(--fs-md2)'}
          color={Colors.black}>
          {label}
        </TextBase>
      ) : null}

      <Input
        placeholder={placeholder}
        style={{ backgroundColor: '#F8F8F8', height: 'calc(var(--fs-hero)*1.17924)', marginTop: 'calc(var(--sp-xxs)*2)', ...inputStyle }}
        onChange={onChange}
        value={value}
        disabled={disabled}
        className={bg === 'light' ? 'form-input-white' : 'form-input-grey'}
        status={error?.length ? 'error' : ''}
      />

      {error?.length ? (
        <TextBase fontWeight={400} size={'calc(var(--fs-xs)*1.32075)'} color={Colors.red}>
          {error || 'Required'}
        </TextBase>
      ) : null}
    </div>
  );
};
